import { BulkMessageStatus } from '@api'

export const enum MassMessageTablesTypes {
  NMM = 'Normal Mass Message',
  PMM = 'Priority Mass Message',
}

export const priorityMassMessageFilterTypes: {
  id: string
  name: string
  value: BulkMessageStatus
}[] = [
  { id: '1', name: 'Pending', value: BulkMessageStatus.PENDING },
  { id: '2', name: 'Running', value: BulkMessageStatus.RUNNING },
  { id: '3', name: 'Cancelled', value: BulkMessageStatus.CANCELLED },
  { id: '4', name: 'Done', value: BulkMessageStatus.DONE },
]
